export const messages = {
  en: {
    printPayFee: {
      apply: 'Application',
      receipt: 'Receipt',
      refund: 'Refund',
      owner: 'Owner',
      receiptNum: 'Receipt No.',
      payTime: 'Payment Time',
      serialNumber: 'No.',
      feeItem: 'Fee Item',
      houseCar: 'House/Vehicle',
      feeRange: 'Fee Range',
      to: 'to',
      none: 'None',
      unitPrice: 'Unit Price',
      areaUsage: 'Area/Usage',
      paymentMethod: 'Payment Method',
      receivableActual: 'Receivable/Actual',
      yuan: 'yuan',
      discountAmount: 'Discount Amount',
      remark: 'Remark',
      capitalRMB: 'Capital RMB',
      accountDeduction: 'Account Deduction',
      departmentHead: 'Department Head:',
      operator: 'Operator',
      financeReceipt: 'Finance Receipt:',
      customerConfirm: 'Customer Confirm:'
    }
  },
  zh: {
    printPayFee: {
      apply: '申请单',
      receipt: '收据单',
      refund: '退款单',
      owner: '业主',
      receiptNum: '单号',
      payTime: '缴费时间',
      serialNumber: '编号',
      feeItem: '收费项目',
      houseCar: '房屋/车辆',
      feeRange: '收费范围',
      to: '至',
      none: '无',
      unitPrice: '单价',
      areaUsage: '面积/用量',
      paymentMethod: '支付方式',
      receivableActual: '实收',
      yuan: '元',
      discountAmount: '优惠金额',
      remark: '备注',
      capitalRMB: '大写人民币（元）',
      accountDeduction: '账户扣款',
      departmentHead: '部门负责人：',
      operator: '经办人：',
      financeReceipt: '财务收款：',
      customerConfirm: '客户确认：'
}
  },
  'zh-TW': {
    printPayFee: {
      apply: '申請單',
      receipt: '收據單',
      refund: '退款單',
      owner: '業主',
      receiptNum: '單號',
      payTime: '繳費時間',
      serialNumber: '編號',
      feeItem: '收費項目',
      houseCar: '房屋/車輛',
      feeRange: '收費範圍',
      to: '至',
      none: '無',
      unitPrice: '單價',
      areaUsage: '面積/用量',
      paymentMethod: '支付方式',
      receivableActual: '實收',
      yuan: '元',
      discountAmount: '優惠金額',
      remark: '備註',
      capitalRMB: '大寫人民幣（元）',
      accountDeduction: '帳戶扣款',
      departmentHead: '部門負責人：',
      operator: '經辦人：',
      financeReceipt: '財務收款：',
      customerConfirm: '客戶確認：'
    }
  }
}